/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_Tab_RenewInputs */

const en_settings_payments_tab_renew = /** @type {(inputs: Settings_Payments_Tab_RenewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renewal`)
};

/**
* | output |
* | --- |
* | "Renewal" |
*
* @param {Settings_Payments_Tab_RenewInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_payments_tab_renew = /** @type {((inputs?: Settings_Payments_Tab_RenewInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_Tab_RenewInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_payments_tab_renew(inputs)
});
export { settings_payments_tab_renew as "settings.payments.tab_renew" }